import React from "react";
import { NavLink } from 'react-router-dom';
import ethicsPageData from '../content/ethics-page.json';


// Utility function to make links clickable
const makeTextClickable = (text) => {
    return text
      .replace(
        /Guidelines On Good Publication practice/,
        `<a href="https://publicationethics.org/about/what-we-do/our-story/history-code-conduct" target="_blank" rel="noopener noreferrer">Guidelines On Good Publication practice</a>`
      )
      .replace(
        /Core Practices/,
        `<a href="https://publicationethics.org/about/what-we-do/our-story/why-core-practices-were-replaced-topics" target="_blank" rel="noopener noreferrer">Core Practices</a>`
      );
};
  
const RenderTextWithLinks = (text) => {
    const htmlText = makeTextClickable(text);
    return <span dangerouslySetInnerHTML={{ __html: htmlText }} />;
};

const EthicsPageContent = () => (
    <div>
        <section className="main-section">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="main-text">
                            <h2>Ethical Guidelines</h2>
                            <div className="bt-option">
                                <NavLink to="/">Home</NavLink>
                                <span>Ethics</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        
        <section className="ethics-section spad">
            <div class="container">
                <div class="section-title">
                    <p class="f-para">{RenderTextWithLinks(ethicsPageData.text)}</p>
                </div>
                
                <div class="section-title">
                    <h3>{ethicsPageData.other.header}</h3>
                    <div>
                        {ethicsPageData.other.guidelines.map((guideline, guidelineIndex) => (
                            <div>
                                <h5 key={guidelineIndex}><strong>{guideline.title}</strong></h5>
                                {guideline.text && <p className="f-para">{guideline.text}</p>}
                                {guideline.array && 
                                    <ul>
                                        {guideline.array.map((item, index) => (
                                        <div key={index}>
                                            {item.prefix ? (
                                                <li><strong>{item.prefix}</strong> {item.text}</li>
                                            ) : item.subtitle && item.array ? (
                                                <div>
                                                    <h5>{item.subtitle}</h5>
                                                    <div class="guideline-subsection">
                                                        <ul>
                                                            {item.array.map((subItem, subIndex) => (
                                                            <div key={subIndex}>
                                                                <li><strong>{subItem.prefix}</strong> {subItem.text}</li>
                                                            </div>
                                                            ))}
                                                        </ul>
                                                    </div>
                                                </div>
                                            ) : null}
                                        </div>
                                        ))}
                                    </ul>
                                }
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    </div>
);

export default EthicsPageContent;